import { createApp } from "vue";
// import piniaPluginPersistedstate from 'pinia-plugin-persistedstate'
import { ApolloClient, createHttpLink, InMemoryCache } from "@apollo/client/core";
import { DefaultApolloClient, provideApolloClient } from "@vue/apollo-composable";
import { setContext } from "@apollo/client/link/context";
import { animateComponents, animateHero } from "~/js/utils/animation.ts";

import ContentBuilder from "~/vue/ContentBuilder.vue";

// Main app
const contentBuilder = async () => {
	const app = createApp(ContentBuilder);

	const httpLink = createHttpLink({
		uri: import.meta.env.VITE_GQL_URL ?? `${window.location.origin}/api`,
	});

	const authLink = setContext((_, { headers }) => {
		return {
			headers: {
				...headers,
				authorization: `Bearer ${import.meta.env.VITE_GQL_TOKEN ?? ""}`,
			},
		};
	});

	// Create the apollo client
	const apolloProvider = new ApolloClient({
		link: authLink.concat(httpLink),
		cache: new InMemoryCache(),
	});

	provideApolloClient(apolloProvider);
	app.provide(DefaultApolloClient, apolloProvider);

	app.use(window.pinia);

	return app.mount("#content-builder");
};

// Execute async function
contentBuilder().then(() => {
	animateHero();
	animateComponents();
});

// Accept HMR as per: https://vitejs.dev/guide/api-hmr.html
if (import.meta.hot) {
	import.meta.hot.accept(() => {
		console.log("HMR active");
	});
}
